import React, { createContext, useContext } from "react";
import { useAuth } from "@frontegg/react";
import { useQuery } from "@apollo/client";
import { GET_MENTIONABLE_USERS } from "graphql/user";
import { User } from "hooks/useGetLoggedInUser";

type UserMentionContextType = {
  users: User[];
  loading: boolean;
  error?: any;
  refetch: () => void;
};

const UserMentionContext = createContext<UserMentionContextType>({
  users: [],
  loading: true,
  refetch: () => {},
});

export const useUserMentions = () => useContext(UserMentionContext);

export const UserMentionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();
  const { data, loading, error, refetch } = useQuery(GET_MENTIONABLE_USERS, {
    skip: !isAuthenticated,
    fetchPolicy: "network-only",
  });

  const users: User[] = Array.isArray(data?.mentionableUsers)
    ? data.mentionableUsers.map((user: any) => ({
        id: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        profilePicUrl: user.profilePicUrl,
      }))
    : [];

  return (
    <UserMentionContext.Provider value={{ users, loading, error, refetch }}>
      {children}
    </UserMentionContext.Provider>
  );
};
